import { useState } from "react";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import ListBanquesToPayement from "../../../models/ListBanquesToPayement";
import withLoader from "../../../components/layouts/WithLoader";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import TierAccountService from "../../../services/PayementSolde/TierAccountService";
import { useNavigate } from "react-router-dom";

const ChargerWalletEspece = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [amount, setAmount] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const changeAmount = (event) => {
    setAmount(event.target.value);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const payerBill = (e) => {
    const url = window.location.pathname.split("/")[1];
    if (url === "chargerWallet") {
      if (amount === "") {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : Le montant est vide ");
      } else {
        let walletModel = {
          idUser: getCurrentUserId(),
          idBa: parseInt(localStorage.getItem("banqueAccount")),
          idWallet: parseInt(sessionStorage.getItem("idWallet")),
          typePayement: 0,
          ammountPayed: amount,
          urlFile: "any",
        };
        startLoading();
        TierAccountService.addWalletPayement(walletModel)
          .then((response) => {
            console.log(response);
            if (response.data["error"]) {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur :  " + response.data["error"]);
            } else {
              setOpenSuccessAlert(true);
              setSuccessAlertText("Enregistrement avec succées");
              setTimeout(() => {
                navigate(`/walletClient`);
              }, 2000);
            }
          })
          .catch((error) => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :  " + error);
          })
          .finally(() => {
            stopLoading();
          });
      }
    } else if (url === "chargerWalletFournisseur") {

      if (amount === "") {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : Le montant est vide ");
      } else {
        let walletModel = {
          idUser: getCurrentUserId(),
          idBa: parseInt(localStorage.getItem("banqueAccount")),
          idWallet: parseInt(sessionStorage.getItem("idWallet")),
          typePayement: 0,
          ammountPayed: amount,
          urlFile: "any",
        };
        startLoading();
        TierAccountService.addWalletPayementFournisseur(walletModel)
          .then((response) => {
            console.log(response);
            if (response.data["error"]) {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur :  " + response.data["error"]);
            } else {
              setOpenSuccessAlert(true);
              setSuccessAlertText("Enregistrement avec succées");
              setTimeout(() => {
                navigate(`/walletFournisseur`);
              }, 2000);
            }
          })
          .catch((error) => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :  " + error);
          })
          .finally(() => {
            stopLoading();
          });
      }
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <label>Charger par espèce: </label>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <label>Montant : </label>
          <input
            type="number"
            min="0"
            step="0.1"
            //   max={this.props.restToPay.toString()}
            class="form-control"
            placeholder="Montant "
            name="amount"
            value={amount}
            onChange={changeAmount}
          />
        </div>
        <div class="col-md-8">
          <label>Caisse : </label>
          <ListBanquesToPayement type={2} />
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-12">
          <button
            type="submit"
            onClick={payerBill}
            className="btn btn-dark float-right"
          >
            Payer
          </button>
        </div>
      </div>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};
export default withLoader(ChargerWalletEspece);
